import { useRef, useState } from 'react';
import styles from '../Portfolio/Portfolio.module.css';
import { ProjectData } from '../../data/ProjectData';
import Cards from './Cards/Cards';
import Reveal from '../Reveal/Reveal';
import SectionTitle from '../SectionTitle/SectionTitle';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { AppConstants } from '../../AppConstants';

const Portfolio = () => {
    const [showAll, setShowAll] = useState(false);
    const portfolioSectionRef = useRef(null);
    const displayedCards = showAll ? ProjectData : ProjectData.slice(0, 4);

    const handleToggleCards = () => {
        if (showAll) {
            portfolioSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        setShowAll(!showAll);
    };

    return (
        <section
            id="portfolio"
            className={styles.portfolio}
            ref={portfolioSectionRef}
        >
            <Reveal>
                <div className="container">
                    <SectionTitle>
                        {AppConstants.CommonWords.Selected} <span>{AppConstants.CommonWords.Works}</span>
                    </SectionTitle>
                    <ul className={styles.card}>
                        {displayedCards.map((item) => (
                            <Cards
                                key={item.id}
                                image={item.img}
                                title={item.title}
                                demo={item.demo}
                                description={item.description}
                                technologies={item.technologies}
                            />
                        ))}
                    </ul>
                    {ProjectData.length > 4 && (
                        <div className={styles.btncnt}>
                            <button
                                className={styles.button}
                                onClick={handleToggleCards}
                            >
                                {showAll ? <IoIosArrowUp size={32} /> : <IoIosArrowDown size={32} />}
                            </button>
                        </div>
                    )}
                </div>
            </Reveal>
        </section>
    );
};

export default Portfolio;
